import * as Const from '../constants';

export const validateDateFrom = (): string => {
  return Const.CHANGE_DATE_FROM_FAIL;
};

export const validateDateTo = (dateFrom, dateTo): string => {
  if (dateFrom && dateTo <= dateFrom) {
    return Const.INVALID_DATE_RANGE;
  }
  return null;
};
